import { Box, HStack, usePrefersReducedMotion } from '@chakra-ui/react';
import { TextLink } from '@time-line/components/common';
import { pulse } from 'theme/keyframes';
import type { LiveNotification } from 'types/cms/ToastNotification';

const DOT_SIZE = 8;

export const LiveNow = ({ url }: LiveNotification) => {
  const prefersReducedMotion = usePrefersReducedMotion();
  const pulseAnimation = prefersReducedMotion
    ? undefined
    : `${pulse(2.25)} 2s infinite cubic-bezier(0, 0, 0.5, 1)`;

  return (
    <HStack gap="4xs" alignItems="center">
      <Box
        display="inline-block"
        w={`${DOT_SIZE}px`}
        h={`${DOT_SIZE}px`}
        borderRadius="full"
        bg="red.100"
        position="relative"
        _after={{
          content: "''",
          position: 'absolute',
          width: '100%',
          height: '100%',
          bg: 'red.100',
          borderRadius: 'full',
          animation: pulseAnimation,
        }}
      />
      <TextLink
        href={url}
        textProps={{
          size: 'detail',
          color: 'red.100',
          fontWeight: 'medium',
          lineHeight: 'normal',
        }}
      >
        Live now
      </TextLink>
    </HStack>
  );
};
